import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { FiLock, FiLogIn } from "react-icons/fi";
import { login } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ApiCallError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import LangSwitch from "@/components/LangSwitch";
import { useI18n } from "@/lib/i18n";

export default function LoginPage() {
  const { user, setUser } = useAuth();
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/" replace />;

  return (
    <div className="flex h-full items-center justify-center bg-slate-950 p-4">
      <form
        onSubmit={async (ev) => {
          ev.preventDefault();
          setErr(null);
          setBusy(true);
          try {
            const r = await login(email, pw);
            setUser({ id: 0, email: r.email, role: r.role });
            nav("/");
          } catch (e) {
            const msg = e instanceof ApiCallError ? e.message : String(e);
            setErr(msg);
          } finally {
            setBusy(false);
          }
        }}
        className="w-full max-w-sm space-y-4 rounded-md border border-slate-800 bg-card p-4 md:p-6"
      >
        <div className="flex items-center justify-between gap-2">
          <span className="flex items-center gap-2 text-base font-semibold">
            <FiLock /> {t("app.name")}
          </span>
          <LangSwitch />
        </div>
        <div className="space-y-1">
          <label htmlFor="login-email" className="text-[11px] uppercase tracking-wide text-slate-400">
            {t("login.email")}
          </label>
          <Input
            id="login-email"
            type="email"
            name="email"
            autoComplete="username"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="you@jalabyte.id"
            className="h-10"
          />
        </div>
        <div className="space-y-1">
          <label htmlFor="login-password" className="text-[11px] uppercase tracking-wide text-slate-400">
            {t("login.password")}
          </label>
          <Input
            id="login-password"
            type="password"
            name="password"
            autoComplete="current-password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            required
            className="h-10"
          />
        </div>
        {err && <div className="text-xs text-signal-crit">{err}</div>}
        <Button type="submit" disabled={busy} className="h-10 w-full">
          <FiLogIn /> {busy ? t("login.busy") : t("login.submit")}
        </Button>
      </form>
    </div>
  );
}
